"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDR = exports.LANDING_PAGE_PLACEHOLDERS = exports.WIDGET_SECONDARY_CTA = exports.WIDGET_SECONDARY_DESC = exports.WIDGET_SECONDARY_TITLE = exports.WIDGET_DEFAULT_CTA = exports.WIDGET_DEFAULT_DESC = exports.WIDGET_DEFAULT_TITLE = exports.MILLISECONDS_IN_A_DAY = exports.MILLISECONDS_IN_AN_HOUR = exports.MILLISECONDS_IN_A_MINUTE = exports.MILLISECONDS_IN_A_SECOND = exports.SECONDS_IN_A_MINUTE = exports.SECONDS_IN_AN_HOUR = exports.SECONDS_IN_A_DAY = void 0;
const find_1 = __importDefault(require("lodash/find"));
exports.SECONDS_IN_A_DAY = 86400;
exports.SECONDS_IN_AN_HOUR = 3600;
exports.SECONDS_IN_A_MINUTE = 60;
exports.MILLISECONDS_IN_A_SECOND = 1000;
exports.MILLISECONDS_IN_A_MINUTE = exports.SECONDS_IN_A_MINUTE * exports.MILLISECONDS_IN_A_SECOND;
exports.MILLISECONDS_IN_AN_HOUR = exports.SECONDS_IN_AN_HOUR * exports.MILLISECONDS_IN_A_SECOND;
exports.MILLISECONDS_IN_A_DAY = exports.SECONDS_IN_A_DAY * exports.MILLISECONDS_IN_A_SECOND;
exports.WIDGET_DEFAULT_TITLE = 'I\'ll choose where I sit.';
exports.WIDGET_DEFAULT_DESC = 'Find your preferred table and upgrade your dining experience.';
exports.WIDGET_DEFAULT_CTA = 'Choose Your Table';
exports.WIDGET_SECONDARY_TITLE = 'Sit me anywhere.';
exports.WIDGET_SECONDARY_DESC = 'No seating preference? Let our reservation system seat you.';
exports.WIDGET_SECONDARY_CTA = 'Standard Booking';
exports.LANDING_PAGE_PLACEHOLDERS = {
    tablz: {
        title: 'Discover the Best Tables',
        description: 'Access exclusive seats - only with Tablz',
        callToAction: 'Book Your Table'
    },
    alternate: {
        title: 'Sit me anywhere.',
        description: 'No seating preference? Let our reservation system seat you.',
        callToAction: 'Standard booking'
    }
};
var TDR;
(function (TDR) {
    TDR.SUPPORT_EMAIL = 'customersupport@tablz.com';
    //https://console.twilio.com/us1/develop/phone-numbers/manage/incoming/PN5aa741bdd32d1f40c9b7c8018f5423be/configure
    TDR.DUMMY_RESERVATION_NUMBER = '+1 819-303-5704';
    TDR.DEFAULT_BOOKABLE_DAYS = 60;
    TDR.DEFAULT_GRACE_PERIOD_MINUTES = 15;
    TDR.LARGE_GROUP_DEPOSIT_POLICY_NAME = 'LGB Deposit';
    TDR.DEFAULT_RES_DURATION = 120;
    TDR.LOW_INVENTORY_THRESHOLD = 3;
    TDR.MINIMUM_MEDIA_COUNT = 3;
    TDR.MINIMUM_MEDIA_WIDTH = 1920;
    /** 10 minutes, 5 seconds, in seconds */
    TDR.CHECKOUT_DURATION_SECONDS_BACKEND = 605;
    /** 20 minutes, 5 seconds, in seconds */
    TDR.CHECKOUT_DURATION_SECONDS_BACKEND_PRIVATE_EVENTS = 1205;
    let InternalDenialReason;
    (function (InternalDenialReason) {
        InternalDenialReason["PAYMENT_FAILED"] = "Payment failure";
        InternalDenialReason["RESTAURANT_DOUBLE_BOOKED"] = "Restaurant cant accommodate, double booked";
        InternalDenialReason["RESTAURANT_CANT_ACCOMMODATE"] = "Restaurant cant accommodate, other";
        InternalDenialReason["GUEST_NO_LONGER_INTERESTED"] = "Guest no longer interested";
    })(InternalDenialReason = TDR.InternalDenialReason || (TDR.InternalDenialReason = {}));
    let Currency;
    (function (Currency) {
        // AUD = 'aud',
        Currency["CAD"] = "cad";
        Currency["USD"] = "usd";
        Currency["AED"] = "aed";
        Currency["EUR"] = "eur";
        Currency["GBP"] = "gbp";
    })(Currency = TDR.Currency || (TDR.Currency = {}));
    let CurrencySymbol;
    (function (CurrencySymbol) {
        CurrencySymbol["DOLLAR"] = "$";
        CurrencySymbol["DIRHAM"] = "AED";
        CurrencySymbol["EURO"] = "\u20AC";
        CurrencySymbol["POUND"] = "\u00A3";
    })(CurrencySymbol = TDR.CurrencySymbol || (TDR.CurrencySymbol = {}));
    let CurrencyPlacement;
    (function (CurrencyPlacement) {
        CurrencyPlacement["BEFORE"] = "before";
        CurrencyPlacement["AFTER"] = "after";
    })(CurrencyPlacement = TDR.CurrencyPlacement || (TDR.CurrencyPlacement = {}));
    TDR.CurrencyConfig = {
        [Currency.USD]: {
            symbol: TDR.CurrencySymbol.DOLLAR,
            placement: TDR.CurrencyPlacement.BEFORE
        },
        [Currency.EUR]: {
            symbol: TDR.CurrencySymbol.EURO,
            placement: TDR.CurrencyPlacement.BEFORE
        },
        [Currency.CAD]: {
            symbol: TDR.CurrencySymbol.DOLLAR,
            placement: TDR.CurrencyPlacement.BEFORE
        },
        [Currency.AED]: {
            symbol: TDR.CurrencySymbol.DIRHAM,
            placement: TDR.CurrencyPlacement.AFTER
        },
        [Currency.GBP]: {
            symbol: TDR.CurrencySymbol.POUND,
            placement: TDR.CurrencyPlacement.BEFORE
        }
    };
    let Timezone;
    (function (Timezone) {
        Timezone["EASTERN"] = "America/New_York";
        Timezone["CENTRAL"] = "America/Chicago";
        Timezone["MOUNTAIN"] = "America/Denver";
        Timezone["FRANCE"] = "Europe/Paris";
        Timezone["PACIFIC"] = "America/Los_Angeles";
        Timezone["GULF"] = "Asia/Dubai";
        Timezone["LONDON"] = "Europe/London";
    })(Timezone = TDR.Timezone || (TDR.Timezone = {}));
    TDR.DEFAULT_CURRENCY = Currency.CAD;
    let StripeRegion;
    (function (StripeRegion) {
        // AUSTRALIA = 'aus',
        StripeRegion["CANADA"] = "can";
        StripeRegion["USA"] = "usa";
        StripeRegion["LEGACY"] = "legacy";
    })(StripeRegion = TDR.StripeRegion || (TDR.StripeRegion = {}));
    let Country;
    (function (Country) {
        Country["CANADA"] = "Canada";
        Country["USA"] = "United States";
        Country["UAE"] = "United Arab Emirates";
        Country["FRANCE"] = "France";
        Country["UK"] = "United Kingdom";
    })(Country = TDR.Country || (TDR.Country = {}));
    TDR.DEFAULT_STRIPE_REGION = StripeRegion.CANADA;
    TDR.DEFAULT_REFUND_PROCESSING_DAYS = '7-10';
    TDR.DEFAULT_MAX_GUESTS_PER_TABLE = 8;
    TDR.REGIONS = {
        // [StripeRegion.AUSTRALIA]: { region: StripeRegion.AUSTRALIA, currency: Currency.USD, name: 'Australia' },
        [StripeRegion.CANADA]: { region: StripeRegion.CANADA, currency: Currency.CAD, name: 'Canada' },
        [StripeRegion.USA]: { region: StripeRegion.USA, currency: Currency.USD, name: 'United States of America' }
    };
    TDR.DEFAULT_RESERVATION_CUTOFFS = {
        create: { time: '23:59' },
        update: { margin: 12 * exports.SECONDS_IN_AN_HOUR },
        cancel: { margin: 12 * exports.SECONDS_IN_AN_HOUR }
    };
    let Occasion;
    (function (Occasion) {
        /**
         * @deprecated Split into BIRTHDAY and ANNIVERSARY. Retained so reservations booked
         * before the split still validate and display. Not offered in the picker — read
         * SELECTABLE_OCCASIONS for that.
         */
        Occasion["CELEBRATION"] = "celebration";
        Occasion["BIRTHDAY"] = "birthday";
        Occasion["ANNIVERSARY"] = "anniversary";
        Occasion["SOCIAL"] = "social";
        Occasion["BUSINESS"] = "business";
    })(Occasion = TDR.Occasion || (TDR.Occasion = {}));
    /** The occasions a guest can pick at checkout, in display order. Excludes deprecated values. */
    TDR.SELECTABLE_OCCASIONS = [
        Occasion.BIRTHDAY,
        Occasion.ANNIVERSARY,
        Occasion.SOCIAL,
        Occasion.BUSINESS
    ];
    let RMSFormat;
    (function (RMSFormat) {
        RMSFormat["TWO_STARS"] = "two stars";
        RMSFormat["NO_STARS"] = "no stars";
        RMSFormat["TWO_DOTS"] = "two dots";
        RMSFormat["PATIO"] = "patio";
        RMSFormat["STAR_TABLZ"] = "star tablz";
        RMSFormat["END_STARS"] = "end stars";
        RMSFormat["CHAIR_STAR"] = "chair star";
    })(RMSFormat = TDR.RMSFormat || (TDR.RMSFormat = {}));
    TDR.RMSPreview = {
        [RMSFormat.TWO_STARS]: '⭐⭐first last',
        [RMSFormat.NO_STARS]: 'first last',
        [RMSFormat.TWO_DOTS]: '••first last',
        [RMSFormat.PATIO]: '⛱️☀️first last',
        [RMSFormat.STAR_TABLZ]: '⭐️TABLZ - first last',
        [RMSFormat.END_STARS]: 'first last ⭐⭐',
        [RMSFormat.CHAIR_STAR]: '🪑⭐first last'
    };
    TDR.ALTERNATIVE_WIDGET_OPTIONS = ['none', 'tablz', 'opentable'];
    let AlternativePlatform;
    (function (AlternativePlatform) {
        AlternativePlatform["Auphan"] = "auphan";
        AlternativePlatform["Bookenda"] = "bookenda";
        AlternativePlatform["Cvent"] = "cvent";
        AlternativePlatform["EatApp"] = "eatapp";
        AlternativePlatform["Infor"] = "infor";
        AlternativePlatform["JTM"] = "jtm";
        AlternativePlatform["MrBlack"] = "mrblack";
        AlternativePlatform["OftenDining"] = "oftendining";
        AlternativePlatform["OpenTable"] = "opentable";
        AlternativePlatform["Phone"] = "phone";
        AlternativePlatform["Email"] = "email";
        AlternativePlatform["ResDiary"] = "resdiary";
        AlternativePlatform["Resy"] = "resy";
        AlternativePlatform["RezPlus"] = "rezplus";
        AlternativePlatform["SevenRooms"] = "sevenrooms";
        AlternativePlatform["Snappy"] = "snappy";
        AlternativePlatform["Tock"] = "tock";
        AlternativePlatform["TouchBistroDine"] = "touchbistro";
        AlternativePlatform["WaitlistMe"] = "waitlistme";
        AlternativePlatform["Tripleseat"] = "tripleseat";
        AlternativePlatform["Yelp"] = "yelp";
        AlternativePlatform["Custom"] = "custom";
    })(AlternativePlatform = TDR.AlternativePlatform || (TDR.AlternativePlatform = {}));
    // Create an object of AlternativePlatform values as keys and the associated display name as values
    TDR.RMSDisplayNameMap = Object.fromEntries(Object.entries(AlternativePlatform).map(([key, value]) => [value, key]));
    TDR.RMSHexColorMap = {
        OpenTable: '#da3743',
        Resy: '#ff462d',
        SevenRooms: '#4fa6a7',
        Tock: '#344ef4'
    };
    let PartnershipUrlTypes;
    (function (PartnershipUrlTypes) {
        PartnershipUrlTypes["Success"] = "success";
        PartnershipUrlTypes["Register"] = "register";
    })(PartnershipUrlTypes = TDR.PartnershipUrlTypes || (TDR.PartnershipUrlTypes = {}));
    let Weekday;
    (function (Weekday) {
        Weekday["Mon"] = "mon";
        Weekday["Tues"] = "tues";
        Weekday["Wed"] = "wed";
        Weekday["Thurs"] = "thurs";
        Weekday["Fri"] = "fri";
        Weekday["Sat"] = "sat";
        Weekday["Sun"] = "sun";
    })(Weekday = TDR.Weekday || (TDR.Weekday = {}));
    TDR.DEFAULT_SERVICE_NAMES = [
        'Breakfast',
        'Brunch',
        'Lunch',
        'Dinner'
    ];
    TDR.DEFAULT_SEATING_NAMES = [
        'First Seating',
        'Second Seating',
        'Third Seating'
    ];
    let PricingPolicy;
    (function (PricingPolicy) {
        let Charge;
        (function (Charge) {
            Charge.DEFAULT_TARGET = 'total';
        })(Charge = PricingPolicy.Charge || (PricingPolicy.Charge = {}));
    })(PricingPolicy = TDR.PricingPolicy || (TDR.PricingPolicy = {}));
    let SearchConfig;
    (function (SearchConfig) {
        SearchConfig.SECTION_TYPES = [
            'standard-seating',
            'inventory',
            'custom-message',
            'inbound-tablz-restaurant',
            'inbound-direct',
            'inbound-link',
            'events'
        ];
        SearchConfig.INVENTORY_CATEGORIES = [
            'available',
            'x-sell-time',
            'sold-out',
            'x-sell-dates',
            'x-sell-groupsize'
        ];
    })(SearchConfig = TDR.SearchConfig || (TDR.SearchConfig = {}));
    let PinType;
    (function (PinType) {
        PinType["DEFAULT"] = "default";
        PinType["AVAILABLE"] = "available";
        PinType["UNAVAILABLE"] = "unavailable";
        PinType["DISABLED"] = "disabled";
        PinType["LIMITED"] = "limited";
    })(PinType = TDR.PinType || (TDR.PinType = {}));
    let MediaType;
    (function (MediaType) {
        MediaType["IMAGE"] = "image";
        MediaType["VIDEO"] = "video";
    })(MediaType = TDR.MediaType || (TDR.MediaType = {}));
    let TableMediaTag;
    (function (TableMediaTag) {
        TableMediaTag["VIEW_360"] = "360-view";
        TableMediaTag["INSTA"] = "Insta";
        TableMediaTag["PARTNER_PHOTO"] = "Partner-photo";
        TableMediaTag["AI_PHOTO"] = "Ai-photo";
    })(TableMediaTag = TDR.TableMediaTag || (TDR.TableMediaTag = {}));
    /** How a table is booked for a given scenario. Aligns with admin-api's `category` ('instant' | 'request' | 'inquiry'). */
    TDR.BOOKING_TYPES = ['instant', 'request', 'inquiry'];
    let Availability;
    (function (Availability) {
        Availability.LIMITED = 0.6;
        Availability.MONTH_LIMITED = 0.33;
        /**
         * Extended DTO for timeslot calculations (buildMonth, unpackTimeSlots)
         * Includes TableDTO fields plus fields needed for timeslot computations:
         * - restaurantId: for restaurant lookups
         * - slug: for TimeSlotDoc.tableSlug
         * - name: for Reservation.tableName
         * - clusterSize: for multi-reservation tables
         * - defaultTimeSlots: for base timeslot calculation
         * - tags: for restaurant override matching
         * - timeBuffer: for reservation collision detection
         */
        Availability.TABLE_TIMESLOT_DTO_FIELDS = ['id', 'minGuests', 'maxGuests', 'restaurantId', 'slug', 'name', 'clusterSize', 'defaultTimeSlots', 'tags', 'timeBuffer', 'disabled', 'deleted', 'bookingType', 'supportLargeGroup'];
    })(Availability = TDR.Availability || (TDR.Availability = {}));
    let Reservation;
    (function (Reservation) {
        let Filter;
        (function (Filter) {
            Filter["All"] = "all";
            Filter["Booked"] = "booked";
            Filter["Upcoming"] = "upcoming";
            Filter["Completed"] = "completed";
            Filter["Cancelled"] = "cancelled";
            Filter["NoShow"] = "no-show";
        })(Filter = Reservation.Filter || (Reservation.Filter = {}));
        let CommunicationType;
        (function (CommunicationType) {
            CommunicationType["Confirmation"] = "confirmation";
            CommunicationType["Modification"] = "modification";
            CommunicationType["Reminder"] = "reminder";
            CommunicationType["NoShow"] = "no-show";
            CommunicationType["Completed"] = "completed";
            CommunicationType["Cancelled"] = "cancelled";
            CommunicationType["MiscFromCustomer"] = "misc-from-customer";
            CommunicationType["MiscToCustomer"] = "misc-to-customer";
            CommunicationType["LeadGenCustomer"] = "lead-gen-customer";
            CommunicationType["LeadGenRestaurant"] = "lead-gen-restaurant";
            CommunicationType["ConfirmationRequestSubmitted"] = "confirmation-request-submitted";
            CommunicationType["ConfirmationRequestSubmittedWithNewPolicies"] = "confirmation-request-submitted-with-new-policies";
            CommunicationType["ConfirmationRequestAccepted"] = "confirmation-request-accepted";
            CommunicationType["ConfirmationRequestAcceptedWithNewPolicies"] = "confirmation-request-accepted-with-new-policies";
            CommunicationType["ConfirmationRequestDenied"] = "confirmation-request-denied";
            CommunicationType["ConfirmationModificationSubmitted"] = "confirmation-modification-submitted";
            CommunicationType["ConfirmationWithNewPolicies"] = "confirmation-with-new-policies";
            CommunicationType["ConfirmationModificationAccepted"] = "confirmation-modification-accepted";
            CommunicationType["ConfirmationModificationDenied"] = "confirmation-modification-denied";
            CommunicationType["ConfirmationProposal"] = "confirmation-proposal";
            CommunicationType["ReminderProposal"] = "reminder-proposal";
        })(CommunicationType = Reservation.CommunicationType || (Reservation.CommunicationType = {}));
        let CommunicationChannel;
        (function (CommunicationChannel) {
            CommunicationChannel["Sms"] = "sms";
            CommunicationChannel["Email"] = "email";
        })(CommunicationChannel = Reservation.CommunicationChannel || (Reservation.CommunicationChannel = {}));
        /*
        https://www.twilio.com/docs/sms/api/message-resource#message-status-values

        The following are the possible values for the 'Status' parameter:
        Status       Description
        accepted     Twilio has received your API request to send a message with a Messaging Service and a From number is being dynamically selected. This will be the initial status when sending with a Messaging Service and the From parameter.
        queued       The API request to send a message was successful and the message is queued to be sent out. This will be the initial status when you are not using a Messaging Service.
        sending      Twilio is in the process of dispatching your message to the nearest upstream carrier in the network.
        sent         The nearest upstream carrier accepted the message.
        receiving    The inbound message has been received by Twilio and is currently being processed.
        received     On inbound messages only. The inbound message was received by one of your Twilio numbers.
        delivered    Twilio has received confirmation of message delivery from the upstream carrier, and, where available, the destination handset.
        undelivered  Twilio has received a delivery receipt indicating that the message was not delivered. This can happen for many reasons including carrier content filtering and the availability of the destination handset.
        failed       The message could not be sent. This can happen for various reasons including queue overflows, account suspensions and media errors (in the case of MMS). Twilio does not charge you for failed messages.
        read         On WhatsApp messages only. The message has been delivered and opened by the recipient in the conversation. The recipient must have enabled read receipts.
        */
        let TkMessageStatus;
        (function (TkMessageStatus) {
            TkMessageStatus["Created"] = "created";
            TkMessageStatus["Pending"] = "pending";
            TkMessageStatus["Unread"] = "unread";
        })(TkMessageStatus = Reservation.TkMessageStatus || (Reservation.TkMessageStatus = {}));
        let TwilioMessageStatus;
        (function (TwilioMessageStatus) {
            // twilio statuses
            TwilioMessageStatus["Accepted"] = "accepted";
            TwilioMessageStatus["Queued"] = "queued";
            TwilioMessageStatus["Sending"] = "sending";
            TwilioMessageStatus["Sent"] = "sent";
            TwilioMessageStatus["Receiving"] = "receiving";
            TwilioMessageStatus["Received"] = "received";
            TwilioMessageStatus["Delivered"] = "delivered";
            TwilioMessageStatus["Undelivered"] = "undelivered";
            TwilioMessageStatus["Failed"] = "failed";
            TwilioMessageStatus["Read"] = "read";
        })(TwilioMessageStatus = Reservation.TwilioMessageStatus || (Reservation.TwilioMessageStatus = {}));
        let SendgridEmailStatus;
        (function (SendgridEmailStatus) {
            SendgridEmailStatus["Processed"] = "processed";
            SendgridEmailStatus["Dropped"] = "dropped";
            SendgridEmailStatus["Delivered"] = "delivered";
            SendgridEmailStatus["Deferred"] = "deferred";
            SendgridEmailStatus["Bounce"] = "bounce";
        })(SendgridEmailStatus = Reservation.SendgridEmailStatus || (Reservation.SendgridEmailStatus = {}));
        let SendgridEngagement;
        (function (SendgridEngagement) {
            SendgridEngagement["Open"] = "open";
            SendgridEngagement["Click"] = "click";
            SendgridEngagement["Spam"] = "spam report";
            SendgridEngagement["Unsubscribe"] = "unsubscribe";
            SendgridEngagement["GroupUnsubscribe"] = "group unsubscribe";
            SendgridEngagement["GroupResubscribe"] = "group resubscribe";
        })(SendgridEngagement = Reservation.SendgridEngagement || (Reservation.SendgridEngagement = {}));
        const FAILED_STATUSES = [
            TwilioMessageStatus.Failed,
            TwilioMessageStatus.Undelivered,
            SendgridEmailStatus.Dropped,
            SendgridEmailStatus.Deferred,
            SendgridEmailStatus.Bounce
        ];
        function messageStatusFailed(status) {
            return !!(0, find_1.default)(FAILED_STATUSES, fail => fail === status);
        }
        Reservation.messageStatusFailed = messageStatusFailed;
        let Status;
        (function (Status) {
            Status["Pending"] = "pending";
            Status["Failed"] = "failed";
            Status["Booked"] = "booked";
            Status["Submitted"] = "submitted";
            Status["LeftMessage"] = "left-message";
            Status["Confirmed"] = "confirmed";
            Status["LateArrival"] = "late-arrival";
            Status["PartiallyArrived"] = "partially-arrived";
            Status["Arrived"] = "arrived";
            Status["NoShow"] = "no-show";
            Status["Cancelled"] = "cancelled";
            Status["Reminded"] = "reminded";
            Status["Completed"] = "completed";
        })(Status = Reservation.Status || (Reservation.Status = {}));
        let LargeGroupStatus;
        (function (LargeGroupStatus) {
            LargeGroupStatus["AdminActionRequired"] = "admin-action-required";
            LargeGroupStatus["GuestActionRequired"] = "guest-action-required";
            LargeGroupStatus["Approved"] = "approved";
            LargeGroupStatus["Denied"] = "denied";
            //temporary solution until booking modes and inquires are released.
            LargeGroupStatus["Sent"] = "sent";
        })(LargeGroupStatus = Reservation.LargeGroupStatus || (Reservation.LargeGroupStatus = {}));
        let ModificationDoneStatus;
        (function (ModificationDoneStatus) {
            ModificationDoneStatus["Modified"] = "Modified";
            ModificationDoneStatus["Cancelled"] = "Cancelled";
            ModificationDoneStatus["ModificationPassedCutOffPeriod"] = "ModificationPassedCutOffPeriod";
            ModificationDoneStatus["CancellationPassedCutOffPeriod"] = "CancellationPassedCutOffPeriod";
        })(ModificationDoneStatus = Reservation.ModificationDoneStatus || (Reservation.ModificationDoneStatus = {}));
        let Group;
        (function (Group) {
            Group["Waitlist"] = "Waitlist";
            Group["Reservation"] = "Reservation";
            Group["NoShow"] = "No-Show";
            Group["Cancellation"] = "Cancellation";
            Group["CurrentlySeated"] = "Currently Seated";
        })(Group = Reservation.Group || (Reservation.Group = {}));
        let ItemType;
        (function (ItemType) {
            ItemType["Table"] = "table";
            ItemType["AddOn"] = "addon";
            ItemType["Experience"] = "experience";
            ItemType["Restaurant"] = "restaurant";
            ItemType["Invoice"] = "invoice";
            ItemType["StripeFee"] = "stripeFee";
            ItemType["Refund"] = "refund";
            ItemType["Deposit"] = "deposit";
            ItemType["Coupon"] = "coupon";
        })(ItemType = Reservation.ItemType || (Reservation.ItemType = {}));
        Reservation.UPDATE_KEYS = [
            'id', 'status', 'items', 'guests',
            'tableId', 'tableSlug', 'tableName', 'internalTableName', 'tableType',
            'time', 'epoch',
            'price', 'lockedMinimumPrice', 'largeGroupOptions',
            'phone', 'email', 'fullName', 'firstName', 'lastName', 'guestNotes', 'occasion', 'companyName', 'eventDuration', 'estimatedBudget'
        ];
        let ErrorMessages;
        (function (ErrorMessages) {
            ErrorMessages["TIMESLOT_UNAVAILABLE"] = "Timeslot no longer available. Please select another.";
            ErrorMessages["DOUBLE_BOOKING"] = "To ensure fair availability to all of our guests, only one table at a time can be booked per party.";
            /** The change would move the booking across the instant/request boundary. Staff can do
             *  this deliberately from admin; a guest cannot, since it would either drop admin
             *  oversight or silently turn a confirmed booking into a pending request. */
            ErrorMessages["BOOKING_TYPE_CHANGED"] = "This change requires confirmation from the restaurant. Please contact us directly and we will be happy to help.";
        })(ErrorMessages = Reservation.ErrorMessages || (Reservation.ErrorMessages = {}));
    })(Reservation = TDR.Reservation || (TDR.Reservation = {}));
    let Invoice;
    (function (Invoice) {
        let PartyType;
        (function (PartyType) {
            PartyType["RESTAURANT"] = "restaurant";
            PartyType["USER"] = "user";
            PartyType["TK"] = "tk";
            PartyType["TAX"] = "tax";
            PartyType["STRIPE"] = "stripe";
        })(PartyType = Invoice.PartyType || (Invoice.PartyType = {}));
        let Filter;
        (function (Filter) {
            Filter["All"] = "all";
            Filter["Completed"] = "completed";
            Filter["Cancelled"] = "cancelled";
            Filter["NoShow"] = "no-show";
            Filter["Unrealized"] = "unrealized";
            Filter["Outstanding"] = "outstanding"; // completed, but restaurant hasn't been paid yet
        })(Filter = Invoice.Filter || (Invoice.Filter = {}));
    })(Invoice = TDR.Invoice || (TDR.Invoice = {}));
    let Attributes;
    (function (Attributes) {
        let AttributeType;
        (function (AttributeType) {
            AttributeType["AMBIANCE"] = "ambiance";
            AttributeType["VIEW"] = "view";
            AttributeType["SPACIAL"] = "spacial";
        })(AttributeType = Attributes.AttributeType || (Attributes.AttributeType = {}));
        let AmbianceOptions;
        (function (AmbianceOptions) {
            AmbianceOptions["ROMANTIC"] = "romantic";
            AmbianceOptions["BUSINESS"] = "business";
            AmbianceOptions["SOCIAL"] = "social";
        })(AmbianceOptions = Attributes.AmbianceOptions || (Attributes.AmbianceOptions = {}));
        let ViewOptions;
        (function (ViewOptions) {
            ViewOptions["WATERFRONT"] = "waterfront";
            ViewOptions["SKYLINE"] = "skyline";
            ViewOptions["STREET"] = "street";
            ViewOptions["GARDEN"] = "garden";
            ViewOptions["SUNSET"] = "sunset";
            ViewOptions["BEACH"] = "beach";
            ViewOptions["KITCHEN"] = "kitchen";
            ViewOptions["STAGE"] = "stage";
            ViewOptions["NO_STAGE"] = "no stage";
            ViewOptions["LIMITED_STAGE"] = "limited stage";
            ViewOptions["FIREWORKS"] = "fireworks";
            ViewOptions["TELEVISION"] = "television";
        })(ViewOptions = Attributes.ViewOptions || (Attributes.ViewOptions = {}));
        let SpacialOptions;
        (function (SpacialOptions) {
            SpacialOptions["PRIVATE"] = "private";
            SpacialOptions["SEMI_PRIVATE"] = "semi-private";
        })(SpacialOptions = Attributes.SpacialOptions || (Attributes.SpacialOptions = {}));
        Attributes.OptionConfig = {
            [AttributeType.AMBIANCE]: AmbianceOptions,
            [AttributeType.SPACIAL]: SpacialOptions,
            [AttributeType.VIEW]: ViewOptions
        };
        Attributes.IconMapping = {
            [AmbianceOptions.ROMANTIC]: 'Heart',
            [AmbianceOptions.BUSINESS]: 'Briefcase',
            [AmbianceOptions.SOCIAL]: 'People',
            [ViewOptions.WATERFRONT]: 'Tablz__Waterfront',
            [ViewOptions.SKYLINE]: 'Buildings',
            [ViewOptions.STREET]: 'Driving',
            [ViewOptions.GARDEN]: 'Tree',
            [ViewOptions.SUNSET]: 'SunFog',
            [ViewOptions.BEACH]: 'Tablz__Beach',
            [ViewOptions.KITCHEN]: 'ChemicalGlass',
            [ViewOptions.STAGE]: 'Microphone',
            [ViewOptions.NO_STAGE]: 'MicrophoneSlash',
            [ViewOptions.LIMITED_STAGE]: 'Microphone2',
            [ViewOptions.FIREWORKS]: 'MagicStar',
            [ViewOptions.TELEVISION]: 'MirroringScreen',
            [SpacialOptions.PRIVATE]: 'EyeSlash',
            [SpacialOptions.SEMI_PRIVATE]: 'Eye'
        };
    })(Attributes = TDR.Attributes || (TDR.Attributes = {}));
    let Ecommerce;
    (function (Ecommerce) {
        let ScenarioParameter;
        (function (ScenarioParameter) {
            ScenarioParameter["GroupSize"] = "groupsize";
            ScenarioParameter["Date"] = "date";
            ScenarioParameter["Time"] = "time";
            ScenarioParameter["Items"] = "items";
        })(ScenarioParameter = Ecommerce.ScenarioParameter || (Ecommerce.ScenarioParameter = {}));
        let ValidationType;
        (function (ValidationType) {
            ValidationType["Open"] = "open";
            ValidationType["SingleMandatory"] = "single-mandatory";
            ValidationType["MixedMandatory"] = "mixed-mandatory";
        })(ValidationType = Ecommerce.ValidationType || (Ecommerce.ValidationType = {}));
        Ecommerce.QuantityMode = {
            SINGLE: 'single',
            GROUP_SIZE: 'groupsize'
        };
    })(Ecommerce = TDR.Ecommerce || (TDR.Ecommerce = {}));
    let FeatureFlagString;
    (function (FeatureFlagString) {
        FeatureFlagString["flipLandingModal"] = "Flip landing modal to show alternative platform first";
        FeatureFlagString["widgetLayoutLandingPageTest"] = "Run an A/B test between old landing page and new widget layout version";
        FeatureFlagString["widgetLayoutLandingPage"] = "Force the new widget layout landing page (no A/B test)";
        FeatureFlagString["educationalComponents"] = "Enable educational components";
        FeatureFlagString["patio"] = "Restaurant has patio (requires additional configuration)";
        FeatureFlagString["newCheckout"] = "Enable new checkout layout";
        FeatureFlagString["sameDayBooking"] = "Enable Same Day Booking (requires additional configuration)";
        FeatureFlagString["largeGroupInbounds"] = "Enable large group inbounds prompts for restaurants without Large Group Tables";
        FeatureFlagString["premiumChooseCopyExperiment"] = "Enable the testing of \"Should where I sit\" vs \"Premium Seating Copy\")";
        FeatureFlagString["hideFreePricing"] = "Enable to hide $0 labels in all booking flows";
        FeatureFlagString["privateEvents"] = "TEMPORARY: Converts LGB table configurations into fake private events inquiries using LGB functionality.";
        FeatureFlagString["ctaExperiment"] = "Enable the testing of simple book now cta";
        FeatureFlagString["inclusivePricing"] = "Enable inclusive pricing display (taxes and fees included in displayed prices)";
        FeatureFlagString["dummyPhoneCopy"] = "Replace phone copy button with dummy phone number (+1 819-303-5704) in admin reservation details";
        FeatureFlagString["hideChargeNoShowFee"] = "Hide the charge no show fee panel in admin invoices";
        FeatureFlagString["hideFromAdminLGBs"] = "Hide LGBs from admin banner and booking requests when filtering by all restaurants";
        FeatureFlagString["hideDateDependentPins"] = "Hide pins in Matterport that require a date change to be available";
        FeatureFlagString["allowDirectRefunds"] = "Allow direct refunds (if disabled, refund requests will be sent via email)";
        FeatureFlagString["selfServe"] = "Replace customer support email with restaurant email in all email templates";
        FeatureFlagString["customEmailBranding"] = "Enable custom B2C email branding for enterprise venues";
    })(FeatureFlagString = TDR.FeatureFlagString || (TDR.FeatureFlagString = {}));
})(TDR || (exports.TDR = TDR = {}));
exports.default = TDR;
//# sourceMappingURL=TDR.js.map